module.exports = __webpack_public_path__ + "media/images/city/001-temple-of-apollo-d03810b49655a3467401f9415c0984c5.svg";